module.exports = __webpack_public_path__ + "static/media/logo-footer.4375a68b.png";